<template>
   <div
      id="material-testimonials"
      :class="breakpoint"
      class="container-fluid container-lg">
      <div
         class="row"
         :class="{ cloaked: cloak }">
         <div class="col-sm-6">
            <div
               class="col-content"
               style="align-items: center">
               <div class="instructions">
                  <h1>Så simpelt er det</h1>
                  <div class="left-col">
                     <div class="step">
                        <div class="timeline">
                           <div
                              class="position-relative"
                              style="width: 28px; height: 28px">
                              <material-icon
                                 class="material-icons"
                                 name="brightness_1"
                                 size="28" />
                              <div
                                 class="position-absolute top-0 left-0 w-100 h-100 d-flex align-items-center justify-content-center text-white fw-bold"
                                 style="color: white; font-size: 18px; line-height: 18px">
                                 1
                              </div>
                           </div>
                           <div class="dots" />
                        </div>
                        <div class="step-text">
                           <h5 class="fw-semibold">Vælg forsikringer</h5>
                           <span>Indtast informationer om det du ønsker at forsikre.</span>
                        </div>
                     </div>
                     <div class="step">
                        <div class="timeline">
                           <div
                              class="position-relative"
                              style="width: 28px; height: 28px">
                              <material-icon
                                 class="material-icons"
                                 name="brightness_1"
                                 size="28" />
                              <div
                                 class="position-absolute top-0 left-0 w-100 h-100 d-flex align-items-center justify-content-center text-white fw-bold"
                                 style="color: white; font-size: 18px; line-height: 18px">
                                 2
                              </div>
                           </div>
                           <div class="dots" />
                        </div>
                        <div class="step-text">
                           <h5 class="fw-semibold">Modtag tilbud</h5>
                           <span>Vi matcher dig med 3 forsikringsselskaber.</span>
                        </div>
                     </div>
                     <div class="step">
                        <div class="timeline">
                           <div class="rasmus-icon smiley" />
                        </div>
                        <div class="step-text">
                           <h5 class="fw-semibold">Vælg det bedste tilbud</h5>
                           <span>Sammenlign dine tilbud og vælg det bedste og billigste.</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-sm-6">
            <div
               class="col-content position-relative"
               style="align-items: center">
               <div
                  class="testimonials px-3"
                  style="max-width: 100%">
                  <hr class="xs-divider d-block d-sm-none dark" />
                  <carousel wrap-around>
                     <slide
                        v-for="(page, idx) in pages"
                        :key="`page-${idx + 1}`">
                        <div class="testimonial-page text-start">
                           <div
                              v-for="person in page"
                              :key="person.name">
                              <div
                                 class="d-flex gap-3"
                                 style="flex-basis: 430px">
                                 <img
                                    class="avatar"
                                    :src="`/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/${person.avatar}`"
                                    :alt="person.name" />
                                 <div class="d-flex flex-column flex-grow-1 align-items-start">
                                    <div class="service">
                                       <img
                                          :src="`/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/${person.service.icon}`"
                                          :style="person.service.style" />
                                    </div>
                                    <div
                                       class="name"
                                       v-text="person.name" />
                                    <div
                                       class="testimonial"
                                       v-html="person.html" />
                                    <div class="rating">
                                       <img
                                          :src="`/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/${person.rating}`" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </slide>
                     <template #addons>
                        <navigation />
                     </template>
                  </carousel>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import { mapGetters } from 'vuex';
import MaterialIcon from '@components/MaterialIcon';

export default {
   name: 'MaterialTestimonialsOld',
   components: {
      MaterialIcon,
      Carousel,
      Slide,
      Navigation,
   },
   data() {
      return {
         index: 0,
         count: 2,
         cloak: true,
      };
   },
   computed: {
      pages() {
         return [
            [
               {
                  name: 'Søren Nøddekær',
                  avatar: 'person_3.png',
                  service: {
                     icon: 'trustpilot.png',
                     style: { maxHeight: '25px' },
                  },
                  rating: 'trustpilot_stars.png',
                  html: 'Jeg fik hurtigt 3 forsikringstilbud og sparede <strong>5400&nbsp;kr.</strong> om året.<br>Anbefaler andre at gøre det samme',
               },
               {
                  name: 'Linda Kristensen',
                  avatar: 'person_4.png',
                  service: {
                     icon: 'trustpilot.png',
                     style: { maxHeight: '25px' },
                  },
                  rating: 'trustpilot_stars.png',
                  html: 'Jeg kunne spare <strong>3500&nbsp;kr.</strong> om året på mine forsikringer og valgte derfor at skifte forsikringsselskab',
               },
            ],
            [
               {
                  name: 'Anita Støvring',
                  avatar: 'person_2.png',
                  service: {
                     icon: 'trustpilot.png',
                     style: { maxHeight: '25px' },
                  },
                  rating: 'trustpilot_stars.png',
                  html: '"<strong>Lynhurtig respons</strong> fra alle. Jeg vil varmt anbefale at bruge jeres tilbud"',
               },
               {
                  name: 'Minna Minor',
                  avatar: 'person_1.png',
                  service: {
                     icon: 'trustpilot.png',
                     style: { maxHeight: '25px' },
                  },
                  rating: 'trustpilot_stars.png',
                  html: '"Kan varmt anbefale Findforsikring.dk, fik 3 tilbud, valgte det bedste tilbud og sparede <strong>2.900&nbsp;kr.</strong>"',
               },
            ],
         ];
      },
      sliderHeight() {
         return '23em';
      },
      ...mapGetters(['breakpoint', 'containerClass']),
   },
   mounted() {
      // setTimeout(() => {
      this.cloak = false;
      // }, 100);
   },
};
</script>

<style lang="scss" scoped>
//noinspection CssUnknownTarget
@import '~/colors.scss';

#material-testimonials {
   background-color: #fff;
   padding-top: 2em;
   padding-bottom: 2em;
   font-size: 17px;
   color: $ff-dark-blue;
   //font-family: 'Amaranth', sans-serif;

   .cloaked {
      visibility: hidden;
   }

   .col-content {
      padding: 1em;
   }

   &.sm,
   &.xs {
      font-size: 15px;
   }

   &.xs {
      //.testimonials {
      //   width: 75vw;
      //   max-width: unset;
      //
      //   .testimonial-page > .flex {
      //      flex-direction: column;
      //
      //      > .avatar {
      //         margin-bottom: 1em;
      //         margin-right: 0;
      //      }
      //
      //      > .flex {
      //         align-items: center;
      //         text-align: center;
      //      }
      //   }
      //}

      .left-col {
         height: unset;
      }

      .col-content,
      .testimonials {
         padding-top: 0;
      }
   }

   .left-col {
      display: flex;
      flex-direction: column;
      margin-top: 2em;
      height: 23em;
   }

   .step {
      flex: 1;
      display: flex;
      line-height: 1.3;
      min-height: 100px;
      max-width: 350px;

      .timeline {
         flex-shrink: 1;
         width: 28px;
         display: flex;
         flex-direction: column;
         align-items: center;
         position: relative;

         //> .material-icons[data-step] {
         //   position: relative;
         //   font-size: 28px;
         //   display: flex;
         //   align-items: center;
         //   justify-content: center;
         //
         //   &::after {
         //      color: white;
         //      position: absolute;
         //      //font-family: 'Amaranth', sans-serif;
         //      font-size: 75%;
         //      line-height: 1;
         //   }
         //
         //   &[data-step='1']::before {
         //      content: '1';
         //   }
         //
         //   &[data-step='2']::before {
         //      content: '2';
         //   }

         /*> span {*/
         /*   position: absolute;*/
         /*   color: #fff;*/
         /*   font-family: 'lato-bold', sans-serif;*/
         /*   font-size: 18px;*/
         /*   line-height: 18px;*/
         /*   margin-top: .05em;*/
         /*   z-index: 100;*/
         /*}*/
         //}

         .dots {
            height: 100%;
            width: 2px;
            box-sizing: border-box;
            margin-right: 1px;
            border-right: 2px dotted #444;
         }
      }

      .step-text {
         flex-grow: 1;
         margin-left: 1.5em;
         font-size: 100%;
         font-family: 'Lato', sans-serif;
         max-width: 16em;

         h5 {
            font-family: 'Amaranth', sans-serif;
            font-size: 120%;
            margin-top: 0;
            margin-bottom: 0.2em;
         }
      }
   }

   .testimonials {
      flex-basis: 320px;
      flex-shrink: 1;
      //padding: 1em;
      box-sizing: content-box;
   }

   .testimonial-page {
      background-color: #fff;
      display: flex;

      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      > .flex {
         align-items: center;
      }

      > * {
         &:not(:first-child) {
            margin-top: 20px;
         }
      }

      .avatar {
         height: 90px;
         width: 90px;
         //margin-right: 30px;
         border: 1px solid #eee;
         border-radius: 50%;
      }

      .service {
         > img {
            max-height: 30px;
         }
      }

      .name {
         //font-family: 'Lato', sans-serif;
         font-weight: bold;
         font-size: 110%;
         margin-top: 0.4em;
         margin-bottom: 0.1em;
      }

      .testimonial {
         //font-family: 'Lato', sans-serif;
         line-height: 1.25;
         font-size: 90%;
      }

      .rating {
         > img {
            max-height: 20px;
            margin-top: 5px;
         }
      }
   }

   :deep() {
      .carousel__next,
      .carousel__prev {
         background-color: var(--ff-dark-blue);
         transform: none;
      }
   }
}
</style>
